/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
export var Trigger = (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close || open;
    }
    Trigger.prototype.isManual = function () { return this.open === 'manual' || this.close === 'manual'; };
    return Trigger;
}());
//# sourceMappingURL=trigger.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/utils/trigger.class.js
// module id = ./node_modules/ngx-bootstrap/utils/trigger.class.js
// module chunks = 5